import React from 'react';

export const PlayerDetailsModal = ({ player, onClose }) => {
  if (!player) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
      <div className="glass-card p-6 rounded-xl shadow-lg w-full max-w-md animate-fadeIn custom-scrollbar" style={{maxHeight: '90vh', overflowY: 'auto'}}>
        <h3 className="text-2xl font-bold gradient-text mb-4 text-center">Player Details</h3>
        <div className="space-y-3 text-gray-300">
          <p><strong>Identifier:</strong> <span className="font-mono text-sm break-all">{player.identifier}</span></p>
          <p><strong>Discord:</strong> {player.discord || 'N/A'}</p>
          <p><strong>Group:</strong> {player.group || 'N/A'}</p>
          <p><strong>Name:</strong> {player.name || 'N/A'}</p>
          {player.accounts && (
            <>
              <p className="font-semibold text-white mt-4">Accounts:</p>
              {Object.entries(player.accounts).map(([key, value]) => (
                <p key={key} className="ml-4"><strong>{key.charAt(0).toUpperCase() + key.slice(1)}:</strong> ${value?.toLocaleString() || '0'}</p>
              ))}
            </>
          )}
          {player.job && (
            <>
              <p className="font-semibold text-white mt-4">Job:</p>
              <p className="ml-4"><strong>Label:</strong> {player.job.label || 'N/A'}</p>
              <p className="ml-4"><strong>Grade:</strong> {player.job.grade_label || 'N/A'}</p>
            </>
          )}
          {player.gang && (
            <>
              <p className="font-semibold text-white mt-4">Gang:</p>
              <p className="ml-4"><strong>Label:</strong> {player.gang.label || 'N/A'}</p>
            </>
          )}
        </div>
        <button
          onClick={onClose}
          className="mt-6 bg-[#316dae] hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-md transition duration-300 w-full"
        >
          Close
        </button>
      </div>
    </div>
  );
};